import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface ICheckCardBinFileRequest {
    excelFile: File;
}

async function checkCardBin(formData: FormData): Promise<any> {
    try {

        return (await axiosInstance.post("/CardBin/CheckUploadedBinListFromExcel", formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })).data;

    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useCheckCardBinFile() {
    return useMutation<any, Error, FormData>((variables) => checkCardBin(variables));
}